import { ProjectToolsPage } from "@/features/projects/project-tools.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/tools/",
)({
  component: ProjectToolsPage,
});
